import styled from "grabcad-ui-elements";

export const LicenseHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ProductLicensesOverview = styled.div<{ disabled: boolean }>`
    background: #fdfdfd;
    border: 0.5px solid #c4c4c4;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 20px;
    display: flex;
    margin: 10px 0;
    cursor: pointer;
    position: relative;
    &:hover {
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    }
    h2 {
        margin-top: -6px;
    }
    .imgHolder {
        background: #fdfdfd;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
        border-radius: 4px;
        width: 130px;
        min-width: 130px;
        height: 130px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-right: 20px;
    }
    dl {
        display: grid;
        grid-template-columns: max-content auto;
        margin: 0 0 -2px 0;
    }
    dt {
        grid-column-start: 1;
        text-align: right;
        &:after {
            content: ":";
        }
    }
    dd {
        grid-column-start: 2;
        margin-left: 10px;
        font-weight: bold;
        // Prevent text from stretching container
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
    }

    .ribbon.label {
        position: absolute;
        left: calc(100% + 1.2em);
    }
`;
